import { PRODUCT_CATEGORY_PAGE } from "routes/route.constant";
import ProductCategory from "./ProductCategory";

const route = {
  path: PRODUCT_CATEGORY_PAGE,
  element: ProductCategory,
};

export default route;
